import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';

import { TextField, AutoComplete } from 'redux-form-material-ui';
import { AutoComplete as MUIAutoComplete } from 'material-ui';

import { BooleanRadioButtons } from 'helpers/BooleanRadioButtons';
import * as validator from 'helpers/Validator';
import * as formatter from 'helpers/Formatter';

import IconButton from 'material-ui/IconButton';
import { MdDelete as DeleteIcon } from 'react-icons/md';
import { MdEdit as EditIcon } from 'react-icons/md';

import FieldItems from 'components/shared/FieldItems/FieldItems';

const cannotBeOther = (value) => {
  if (value && value.toLowerCase() === 'other') return 'Cannot be named other';
};

const FormComponent = (props) => {
  const { name, index, fields } = props;

  return (
    <div key={index}>
      <div className="row" style={{ marginBottom: '25px' }}>
        <div className="row">
          <div className="col-sm-6" style={{ textAlign: 'center' }}>
            <Field
              name={`${name}.item_type`}
              type="text"
              component={AutoComplete}
              validate={[validator.required, cannotBeOther]}
              floatingLabelText="Ancillary Item Name (i.e. Parking)"
              textFieldStyle={{
                marginTop: '-15px',
                fontSize: '14px',
                width: '100%',
              }}
              openOnFocus
              fullWidth
              filter={MUIAutoComplete.fuzzyFilter}
              dataSource={['Monthly Parking', 'Storage Locker', 'Visitor Parking']}
            />
          </div>
          <div className="col-sm-6">
            <Field
              name={`${name}.market_amount`}
              type="text"
              component={TextField}
              validate={[validator.required]}
              floatingLabelText="Monthly Market Rent"
              style={{
                marginTop: '-15px',
                fontSize: '14px',
                width: '100%',
              }}
              {...formatter.currencyMask}
            />
          </div>
        </div>

        <div className="row">
          <div className="col-sm-6">
            <Field
              name={`${name}.market_deposit_amount`}
              type="text"
              component={TextField}
              validate={[validator.required]}
              floatingLabelText="Rent Deposit/LMR"
              style={{
                marginTop: '-15px',
                fontSize: '14px',
                width: '100%',
              }}
              {...formatter.currencyMask}
            />
          </div>

          <div className="col-sm-6">
            <Field
              name={`${name}.market_key_deposit_amount`}
              type="text"
              component={TextField}
              validate={[validator.required]}
              floatingLabelText="Key Deposit"
              style={{
                marginTop: '-15px',
                fontSize: '14px',
                width: '100%',
              }}
              {...formatter.currencyMask}
            />
          </div>
        </div>

        <div className="row">
          <h5
            style={{
              textAlign: 'center',
              marginBottom: '5px',
              marginTop: '25px',
            }}
          >
            Is this item an asset?
          </h5>
          <BooleanRadioButtons
            name={`${name}.is_asset`}
            style={{ width: '187px', margin: 'auto' }}
          />
        </div>
        {(fields.get(index) || {}).is_asset && (
          <div>
            <div className="row">
              <div className={`col-sm-6 col-sm-offset-3`} style={{ textAlign: 'center' }}>
                <Field
                  name={`${name}.asset_number`}
                  type="text"
                  component={TextField}
                  validate={[validator.required]}
                  floatingLabelText="Identification Number"
                  style={{
                    marginTop: '-15px',
                    fontSize: '14px',
                    width: '100%',
                  }}
                />
              </div>
            </div>

            <div className="row">
              <div className={`col-sm-6 col-sm-offset-3`} style={{ textAlign: 'center' }}>
                <h5 style={{ textAlign: 'center', marginBottom: '5px', marginTop: '25px' }}>
                  Is this item available to rent?
                </h5>
                <BooleanRadioButtons
                  name={`${name}.is_rentable`}
                  style={{ width: '187px', margin: 'auto' }}
                />
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

const RenderAncillaryItems = ({ items, onEdit, onDelete, disabled }) => {
  const renderAmount = (item) => {
    return (
      <div className="row">
        <p style={{ marginBottom: '0px' }}>Market Pricing</p>
        <div className="col-sm-4" style={{ paddingLeft: '0px' }}>
          <p>
            {item.market_amount !== undefined &&
              `${formatter.formatMoney(item.market_amount)}/Month`}
          </p>
        </div>
        <div className="col-sm-4">
          <p>
            {item.market_deposit_amount !== undefined &&
              `${formatter.formatMoney(item.market_deposit_amount)} LMR Deposit`}
          </p>
        </div>
        <div className="col-sm-4">
          <p>
            {item.market_key_deposit_amount !== undefined &&
              `${formatter.formatMoney(item.market_key_deposit_amount)} Key Deposit`}
          </p>
        </div>
      </div>
    );
  };

  return (
    <div>
      {items.map((item, index) => {
        const name = item.is_asset ? `${item.item_type} - ${item.asset_number}` : item.item_type;

        return (
          <div
            id="mobile_card"
            key={index}
            style={{ paddingBottom: '0px', textTransform: 'capitalize' }}
          >
            {!disabled && onDelete && (
              <IconButton
                style={{ float: 'right', padding: '0px', backgroundColor: 'white' }}
                onClick={() => onDelete(index)}
              >
                <DeleteIcon size={24} style={{ padding: '0px' }} />
              </IconButton>
            )}

            {!disabled && onEdit && (
              <IconButton
                style={{
                  float: 'right',
                  padding: '0px',
                  marginRight: '25px',
                  backgroundColor: 'white',
                }}
                onClick={() => onEdit(index)}
              >
                <EditIcon size={24} style={{ padding: '0px' }} />
              </IconButton>
            )}

            <div className="row">
              <div className="mobile_header">
                <p>{name}</p>
              </div>
              <div className="mobile_subheader">{renderAmount(item)}</div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

class AncillaryItems extends Component {
  render() {
    const { handleSubmit } = this.props;

    return (
      <div className="row" style={{ marginBottom: '25px' }}>
        <div>
          <h3 style={{ textAlign: 'center', margin: '25px 0px 5px 0px' }}>Ancillary Item(s)</h3>
          <p style={{ textAlign: 'center', marginBottom: '15px' }}>
            Create ancillary items below, such as monthly parking, visitor parking or storage
            lockers. If the item has an identification number (such as a parking stall number or
            locker number), click "yes" for is this item an asset and fill in the identification
            number.
          </p>
        </div>

        <form onSubmit={handleSubmit}>
          <FieldItems
            name="ancillary_items"
            formName={this.props.form}
            renderSavedItems={RenderAncillaryItems}
            renderForm={FormComponent}
            dialogHeader="Add Lease Item"
          />
        </form>

        <div id="button" style={{ marginBottom: '75px' }} />
      </div>
    );
  }
}

AncillaryItems = reduxForm({
  form: 'add_property',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
})(AncillaryItems);

export default AncillaryItems;
